import { SVGELEMENT } from '../../../../../enums/SVGELEMENT.js';
import SVGSHAPE from '../SVGSHAPE.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
// Model Structure
export const svgPolylineAttr = makeAttrStruct([
    ['points'],
    ['fill', 'none'], // Default fill color
    ['stroke', 'currentColor'], // Default stroke color
    ['style']
]);
export const svgPolylineData = makeDataStruct();
export const svgPolylineModel = makeStruct([
    ['attributes', svgPolylineAttr],
    ['data', svgPolylineData]
]);
// Simplified Model
export function svgPolyline(attributes, data) {
    return {
        attributes: attributes || svgPolylineAttr(''),
        data: data || svgPolylineData()
    };
}
/** Creates a Line Shape for an SVG */
export default class SVGPOLYLINE extends SVGSHAPE {
    constructor(node, model) {
        super(node, SVGELEMENT.POLYLINE, model);
    }
}
